<template>
  <v-row class="px-4">
    <!-- LOADER -->
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="py-2">
          Obteniendo Proveedores...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-col cols="12">
      <h2>Estado de Proveedores</h2>
    </v-col>
    <v-col cols="12" md="4">
      <v-data-table
        :headers="headersDisponibles"
        :items="proveedoresDisponibles"
        :search="search"
        dense
        item-key="proveedorId"
        :custom-filter="customFilter"
        :footer-props="{ 'items-per-page-options': [15, 20, 25, -1] }"
        :items-per-page="20"
      >
        <template v-slot:top>
          <v-combobox
            v-model="search"
            :items="tipoProveedores"
            label="Tipo Proveedores"
            hide-details
            outlined
            dense
          ></v-combobox>
        </template>
        <template v-slot:[`item.nombre`]="{ item }">
          <v-row align="center" justify="center">
            <v-col cols="11" class="py-0">{{
              item.nombre.toUpperCase()
            }}</v-col>
            <v-col cols="1" class="pa-0 text-center">
              <v-chip
                x-small
                color="green"
                text-color="white"
                class="pa-1 px-2"
              >
              </v-chip>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.ultimaFechaAsignacion`]="{ item }">
          {{ formatDateTime(item.ultimaFechaAsignacion) }}
        </template>
      </v-data-table>
    </v-col>
    <v-col>
      <v-data-table
        :headers="headersAsignados"
        :items="proveedoresAsignadosFiltered"
        item-key="proveedorId"
        :items-per-page="15"
        single-expand
        :footer-props="{ 'items-per-page-options': [10, 15, 20, -1] }"
        show-expand
        dense
      >
        <template v-slot:top>
          <v-row>
            <v-col class="pt-2 pb-1 pl-7 subtitle-1 font-weight-bold">
              Listado De Proveedores
            </v-col>
            <v-col class="pa-0 pb-1 pl-7">
              <v-btn
                color="green"
                :block="$vuetify.breakpoint.smAndDown"
                dark
                @click="ExportarExcel"
              >
                <v-icon>fas fa-file-download</v-icon>
              </v-btn>
            </v-col>
            <v-col class="pa-0 pb-1 pl-7" cols="12" md="3">
              <v-autocomplete
                v-model="selectedTipoAsistencia"
                :items="list_tipoAsistencia"
                item-text="nombre"
                item-value="nombre"
                label="Tipo De Asistencia"
                clearable
                dense
              >
              </v-autocomplete>
            </v-col>
            <v-col class="pa-0 pb-1 pl-7" cols="12" md="2">
              <v-text-field
                v-model="fechaInicio"
                type="date"
                hide-details
                dense
                label="Desde"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col class="pa-0 pb-1 pl-7" cols="12" md="2">
              <v-text-field
                v-model="fechaFin"
                type="date"
                dense
                hide-details
                label="Hasta"
                :max="new Date().toISOString().substr(0, 10)"
                clearable
              ></v-text-field>
            </v-col>
            <v-col class="pa-0 pb-1 pl-7" cols="12" md="2"
              ><v-btn
                color="primary"
                dark
                :block="$vuetify.breakpoint.smAndDown"
                @click="fetchProveedores"
              >
                Filtrar
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.proveedor`]="{ item }">
          <v-col class="py-1">
            {{ item.proveedor.toUpperCase() }}
          </v-col>
        </template>

        <template v-slot:[`item.totalAsistenciasDia`]="{ item }">
          <v-chip small color="blue" text-color="white">
            {{ item.asistencias.length }}
          </v-chip>
        </template>

        <template v-slot:[`item.totalFinalizados`]="{ item }">
          <v-chip small color="green " text-color="white">
            {{
              item.asistencias.filter((a) => a.estado == "FINALIZADO").length
            }}
          </v-chip>
        </template>

        <template v-slot:[`item.totalEnProceso`]="{ item }">
          <v-chip small color="amber darken-1" text-color="white">
            {{
              item.asistencias.filter((a) => a.estado == "EN PROCESO").length
            }}
          </v-chip>
        </template>

        <template v-slot:[`item.totalBanderazo`]="{ item }">
          <v-chip small color="grey" text-color="white">
            {{
              item.asistencias.filter(
                (a) => a.estado == "SERVICIO MUERTO/BANDERAZO"
              ).length
            }}
          </v-chip>
        </template>

        <template v-slot:[`item.totalCancelado`]="{ item }">
          <v-chip small color="red darken-1" text-color="white">
            {{ item.totalCancelado }}
          </v-chip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            style="background-color: white"
            class="py-1 text-center"
          >
            <v-row class="subtitle-2">
              <v-col class="pa-0">ASISTENCIA</v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">ASIGNACIÓN</v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">CONTACTO</v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">TERMINO</v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">TIEMPO (H)</v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">ESTADO</v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">TIPO</v-col>
            </v-row>
            <v-row
              v-for="asistencia in item.asistencias"
              :key="asistencia.numeroAsistencia"
            >
              <v-col class="pa-0">
                {{ asistencia.numeroAsistencia }}
              </v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">
                <small>
                  {{ formatDateTime(asistencia.fechaAsignacion) }}
                </small>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">
                <small>
                  {{ formatDateTime(asistencia.fechaContacto) }}
                </small>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">
                <small>
                  {{ formatDateTime(asistencia.fechaTermino) }}
                </small>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">
                {{ asistencia.tiempoTranscurrido }}
              </v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">
                {{
                  asistencia.estado == "EN PROCESO" && asistencia.fechaTermino
                    ? "EN TERMINO"
                    : asistencia.estado
                }}
              </v-col>
              <v-divider vertical></v-divider>
              <v-col class="pa-0">
                {{ asistencia.tipoAsistencia }}
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
  
  <script>
import axios from "axios";
import XLSX from "xlsx";
const signalR = require("@microsoft/signalr");

export default {
  name: "ProveedoresAsignados",
  data: () => ({
    connectionProveedores: null,
    proveedores: [],
    proveedoresDisponibles: [],
    proveedoresAsignados: [],
    proveedoresAsignadosFiltered: [],
    timerInterval: null,
    today: new Date().toISOString().substr(0, 10),
    fechaInicio: new Date().toISOString().substr(0, 10),
    fechaFin: new Date().toISOString().substr(0, 10),
    loading: false,
    list_tipoAsistencia: [],
    selectedTipoAsistencia: "TODAS",
    auxilioVial: [
      "ABASTO DE COMBUSTIBLE",
      "CAMBIO DE LLANTA",
      "PASO DE CORRIENTE",
      "MECANICA LIGERA",
      "CERRAJERIA",
    ],
    tipoProveedores: [
      "TODOS",
      "ASESORES EXTERNOS",
      "ASESORES INTERNOS",
      "PROVEEDORES COSTA RICA",
      "PROVEEDORES GUATEMALA",
      "PROVEEDORES HONDURAS",
      "PROVEEDORES NICARAGUA",
      "PROVEEDORES PANAMA",
    ],
    fetchingData: false,
    search: "ASESORES INTERNOS",
    headersDisponibles: [
      {
        text: "Nombre",
        value: "nombre",
        align: "left",
      },
      {
        text: "Ultima Asignación",
        value: "ultimaFechaAsignacion",
        align: "right",
        width: 170,
      },
    ],
    headersAsignados: [
      {
        text: "Nombre",
        value: "proveedor",
        align: "left",
        width: 350,
      },
      {
        text: "Total",
        value: "totalAsistenciasDia",
        align: "center",
      },
      {
        text: "Finalizadas",
        value: "totalFinalizados",
        align: "center",
      },
      {
        text: "Canceladas",
        value: "totalCancelado",
        align: "center",
      },
      {
        text: "Banderazo",
        value: "totalBanderazo",
        align: "center",
      },
      {
        text: "En Proceso",
        value: "totalEnProceso",
        align: "center",
      },
    ],
  }),
  created() {
    if (this.$store.state.usuario) this.loading = true;
    this.listarComboBox();
    this.fetchProveedores();

    this.connectionProveedores = new signalR.HubConnectionBuilder()
      .withAutomaticReconnect()
      .withUrl(process.env.VUE_APP_AXIOS + "/listadoProveedores", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    this.connectionProveedores.on("ProveedoresDisponibles", () => {
      if (this.today == this.fechaInicio && this.today == this.fechaFin) {
        this.fetchProveedores();
      }
    });

    this.connectionProveedores
      .start()
      .then(() => {
        console.log("Conexión establecida");
      })
      .catch((err) => {
        console.error("No se pudo conectar", err);
      });
  },
  methods: {
    customFilter(value, search, item) {
      if (!search || search == "TODOS") {
        return true;
      }

      if (
        search === "ASESORES INTERNOS" &&
        item.tipoProveedor === "ASESORES INTERNOS Y EXTERNOS"
      ) {
        return item.ajustadorInterno === true;
      }

      if (
        search === "ASESORES EXTERNOS" &&
        item.tipoProveedor === "ASESORES INTERNOS Y EXTERNOS"
      ) {
        return item.ajustadorInterno === false;
      }

      if (item.tipoProveedor) {
        return item.tipoProveedor.includes(search);
      }

      return false;
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias/Activas", configuracion)
        .then((res) => {
          const tiposAsistenciaFiltrados = res.data.filter(
            (ta) => !this.auxilioVial.includes(ta.nombre)
          );

          tiposAsistenciaFiltrados.unshift({
            id_tipo_asistencia: 0,
            nombre: "AUXILIO VIAL",
          });

          tiposAsistenciaFiltrados.unshift({
            id_tipo_asistencia: 0,
            nombre: "TODAS",
          });

          this.list_tipoAsistencia = tiposAsistenciaFiltrados;
        })
        .catch((err) => console.error(err));
    },
    ExportarExcel() {
      if (this.proveedoresAsignadosFiltered.length == 0) return;

      let rows = [];

      this.proveedoresAsignadosFiltered.forEach((proveedor) => {
        rows.push([`Proveedor: ${proveedor.proveedor}`]);

        rows.push([
          "TOTAL",
          "FINALIZADOS",
          "EN PROCESO",
          "CANCELADOS",
          "BANDERAZO/SERVICIOMUERTO",
          "EN TRAMITE",
        ]);

        rows.push([
          proveedor.totalAsistenciasDia,
          proveedor.totalFinalizados,
          proveedor.totalEnProceso,
          proveedor.totalCancelado,
          proveedor.totalBanderazo,
          proveedor.totalEnTramite,
        ]);

        rows.push([
          "Número de Asistencia",
          "Fecha Asignación",
          "Fecha Contacto",
          "Fecha Término",
          "Tiempo Transcurrido",
          "Estado",
          "Tipo de Asistencia",
        ]);

        proveedor.asistencias.forEach((asistencia) => {
          rows.push([
            asistencia.numeroAsistencia,
            this.formatDateTime(asistencia.fechaAsignacion),
            this.formatDateTime(asistencia.fechaContacto),
            this.formatDateTime(asistencia.fechaTermino),
            asistencia.tiempoTranscurrido,
            asistencia.estado,
            asistencia.tipoAsistencia,
          ]);
        });

        rows.push([]);
      });

      let data = XLSX.utils.aoa_to_sheet(rows);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, data, "Proveedores");

      XLSX.writeFile(
        workbook,
        `ProvAsignados ${this.fechaInicio} - ${this.fechaFin}.xlsx`
      );
    },

    startTimers() {
      const isHistorico =
        this.today != this.fechaInicio && this.today != this.fechaFin;

      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }

      if (isHistorico) {
        if (this.proveedoresAsignadosFiltered) {
          this.proveedoresAsignadosFiltered.forEach((proveedor) => {
            proveedor.asistencias.forEach((asistencia) => {
              const hasTermino = asistencia.fechaTermino;
              const transcurrido =
                ((hasTermino
                  ? new Date(asistencia.fechaTermino)
                  : new Date(this.today)) -
                  new Date(asistencia.fechaAsignacion)) /
                1000;
              asistencia.tiempoTranscurrido = this.formatTime(transcurrido);
            });
          });
        }
      } else {
        this.timerInterval = setInterval(() => {
          const today = new Date();
          if (this.proveedoresAsignadosFiltered) {
            this.proveedoresAsignadosFiltered.forEach((proveedor) => {
              proveedor.asistencias.forEach((asistencia) => {
                if (!asistencia.fechaTermino) {
                  const transcurrido = Math.floor(
                    (today - new Date(asistencia.fechaAsignacion)) / 1000
                  );
                  asistencia.tiempoTranscurrido = this.formatTime(transcurrido);
                } else {
                  const transcurrido =
                    (new Date(asistencia.fechaTermino) -
                      new Date(asistencia.fechaAsignacion)) /
                    1000;
                  asistencia.tiempoTranscurrido = this.formatTime(transcurrido);
                }
              });
            });
          }
        }, 1000);
      }
    },
    formatDateTime(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      const d = new Date(fecha);

      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      const formattedDate = new Intl.DateTimeFormat("sv-ES", options).format(d);
      return formattedDate;
    },
    formatTime(seconds) {
      const horas = Math.floor(seconds / 3600)
        .toString()
        .padStart(2, "0");
      const minutos = Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const segundos = (seconds % 60).toString().padStart(2, "0");
      return `${horas}:${minutos}:${segundos}`;
    },

    getFechaHoraActual() {
      let today = new Date();
      let fechaGuardado =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
      return fechaGuardado;
    },
    fetchProveedores() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.fetchingData) return;

      const isHistorico =
        this.today != this.fechaInicio && this.today != this.fechaFin;

      axios
        .get(
          `api/DetallexProveedores/ProveedoresDashboard?inicio=${this.fechaInicio}&fin=${this.fechaFin}&historico=${isHistorico}`,
          configuracion
        )
        .then((res) => {
          this.proveedores = res.data;
          this.proveedoresDisponibles = this.proveedores.proveedoresDisponibles;
          this.proveedoresAsignados =
            this.proveedores.proveedoresAsignados.sort(
              (a, b) => b.totalEnProceso - a.totalEnProceso
            );

          if (
            this.selectedTipoAsistencia == "TODAS" ||
            !this.selectedTipoAsistencia
          ) {
            this.proveedoresAsignadosFiltered = this.proveedoresAsignados;
          } else {
            this.proveedoresAsignadosFiltered =
              this.proveedoresAsignados.filter((proveedor) => {
                if (this.selectedTipoAsistencia == "AUXILIO VIAL") {
                  const asistenciasFiltered = proveedor.asistencias.filter(
                    (a) => this.auxilioVial.includes(a.tipoAsistencia)
                  );

                  proveedor.asistencias = asistenciasFiltered;

                  if (asistenciasFiltered.length > 0) {
                    return proveedor;
                  }
                } else {
                  const asistenciasFiltered = proveedor.asistencias.filter(
                    (a) => a.tipoAsistencia == this.selectedTipoAsistencia
                  );

                  proveedor.asistencias = asistenciasFiltered;

                  if (asistenciasFiltered.length > 0) {
                    return proveedor;
                  }
                }
              });
          }

          this.startTimers();
        })
        .catch((err) => console.error(err.response))
        .finally(() => {
          this.fetchingData = false;
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    // Cerrar conexión y eliminar manejadores
    if (this.connectionProveedores) {
      this.connectionProveedores.stop();
      this.connectionProveedores.off("ProveedoresDisponibles");
    }

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
};
</script>
  
<style scoped>
</style>